

import React from "react";

const ContactPage = () => {
  return (
    <>
      {/* ====================================================== */}
      {/*                     BREADCRUMB                        */}
      {/* ====================================================== */}
      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>Contact Us</h1>
          </div>
        </div>
      </section>

      {/* ====================================================== */}
      {/*                 TOP CONTACT DETAILS                    */}
      {/* ====================================================== */}
      <section className="contact-details-section  pb_90">
        <div className="container">
          {/* <div className="section-title centred mb_60"> */}
            {/* <span className="sub-title">Contact Details</span> */}
            {/* <h2 className="title">Contact Information</h2> */}
          {/* </div> */}

          {/* <div className="row">

            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
              <div className="contact-info-item centred">
                <div className="contact-info-icon">
                  <i className="fas fa-phone-alt"></i>
                </div>
                <h4 className="contact-info-title">Phone Numbers</h4>
                <div className="contact-info-text">
                  <a href="tel:+919822136667">+91 9822136667</a>
                  <a href="tel:+917350959600">+91 7350959600</a>
                  <a href="tel:+917507705135">+91 7507705135</a>
                </div>
              </div>
            </div>

            
            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
              <div className="contact-info-item centred">
                <div className="contact-info-icon">
                  <i className="fas fa-envelope"></i>
                </div>
                <h4 className="contact-info-title">Email Address</h4>
                <div className="contact-info-text">
                  <a href="mailto:sanjay.nalawade@punecorporatecars.com">sanjay.nalawade@punecorporatecars.com</a>
                  <a href="mailto:sanjay.nalawade@punecorporatecars.com">
                    sanjay.nalawade@punecorporatecars.com
                  </a>
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
              <div className="contact-info-item centred">
                <div className="contact-info-icon">
                  <i className="fas fa-map-marker-alt"></i>
                </div>
                <h4 className="contact-info-title">Our Location</h4>
                <div className="contact-info-text">
                  <p>
                    Sr.No.38/4/1, Office No.101, First Floor Kharadi Bypass RD,
                    Opposite Prestige Alphatech - BNY Mellon building, Beside Van Heusen
                    Outlet Kharadi, Pune Maharashtra 411014
                  </p>
                </div>
              </div>
            </div>

          </div> */}
        </div>
      </section>

      {/* ====================================================== */}
      {/*            2x2 GRID - CORPORATE HELP DESKS             */}
      {/* ====================================================== */}
      <section className="branch-offices-section pt_90 pb_90 light-bg">
        <div className="container">
          <div className="section-title centred mb_60">
            <span className="sub-title">Corporate Office</span>
            <h2 className="title">Communication & Client Relations</h2>
          </div>

          <div className="row g-4">

            {/* ================= CORPORATE OFFICE ================= */}
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="branch-card helpdesk-box">
                <h5 className="helpdesk-title">
                  Corporate Office – Communication & Client Relations
                  <br />
                  <small>Reservations | Booking Helpdesk 24×7</small>
                </h5>

                <p>
                  {/* Adress:-Sr.No.38/4/1, Office No.101, First Floor Kharadi Bypass RD,
                  Opposite Prestige Alphatech - BNY Mellon building” Beside of Van Heusen
                  Outlet kharadi, Pune Maharashtra 411014 */}


                  Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                </p>

                <p><strong>Email ID:</strong> reservations@punecorporatecars.com</p>

                <p><strong>Operation Help Desk 24×7:</strong> 9822943334 / 9405644855</p>

                <p><strong>Operation Manager:</strong> 9823191484</p>

                <p>
                  <strong>GM Operations:</strong> Prashant Nalawade
                  <br />
                  <strong>Email ID:</strong> gmoperations@punecorporatecars.com
                </p>
              </div>
            </div>

            {/* ================= BILLING HELP DESK ================= */}
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="branch-card helpdesk-box">
                <h5 className="helpdesk-title">Billing Helpdesk</h5>

                <p>
                  {/* Adress:-Sr.No.38/4/1, Office No.101, First Floor Kharadi Bypass RD,
                  Opposite Prestige Alphatech - BNY Mellon building” Beside of Van Heusen
                  Outlet kharadi, Pune Maharashtra 411014 */}
                  Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                </p>

                <p><strong>Email ID:</strong> billing@punecorporatecars.com</p>

                <p><strong>Billing Help Desk:</strong> 9405644855 / 7507705135</p>
              </div>
            </div>

            {/* ================= ACCOUNT HELP DESK ================= */}
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="branch-card helpdesk-box">
                <h5 className="helpdesk-title">Account Helpdesk</h5>

                <p>
                  {/* Adress:-Sr.No.38/4/1, Office No.101, First Floor Kharadi Bypass RD,
                  Opposite Prestige Alphatech - BNY Mellon building” Beside of Van Heusen
                  Outlet kharadi, Pune Maharashtra 411014 */}
                  Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                </p>

                <p><strong>Email ID:</strong> accounts@punecorporatecars.com</p>

                <p><strong>Account Help Desk:</strong> 7057239597 / 7507705135</p>
              </div>
            </div>

            {/* ================= CORPORATE SALES ================= */}
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="branch-card helpdesk-box">
                <h5 className="helpdesk-title">Corporate Sales</h5>

                <p>

                  Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                  {/* Adress:-Sr.No.38/4/1, Office No.101, First Floor Kharadi Bypass RD,
                  Opposite Prestige Alphatech - BNY Mellon building” Beside of Van Heusen
                  Outlet kharadi, Pune Maharashtra 411014 */}
                </p>

                <p><strong>Email ID:</strong> sales@punecorporatecars.com</p>

                <p><strong>Corporate Sales Help Desk:</strong> 9822137565</p>

                <p><strong>Corporate Sales Pan India:</strong> 9822136667 / 7350959600</p>

                <p><strong>Email ID:</strong> sanjay.nalawade@punecorporatecars.com</p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ====================================================== */}
      {/*                INDIA BRANCH OFFICES                    */}
      {/* ====================================================== */}
      <section className="branch-offices-section pt_90 pb_90 light-bg">
        <div className="container">

          <div className="section-title centred mb_60 mt_60">
            <span className="sub-title">Branch Offices</span>
            <h2 className="title">Our Branch Network Across India</h2>
            <p className="text-muted">
              Pune Corporate Cars India Private Limited operates a wide network
              of offices across major Indian cities.
            </p>
          </div>

          <div className="row">

            {/* LEFT COLUMN */}
            <div className="col-lg-6 col-md-6 col-sm-12 mb_30">
              <div className="branch-card">
                <h5>Delhi Office</h5>
                <p>Khasra No. 436, West End Green Farms, Rangpuri, New Delhi-110037</p>
              </div>

              <div className="branch-card">
                <h5>Bengaluru Office</h5>
                <p>12th Cross Road, Garjendra Nagar, Bengaluru, Karnataka</p>
              </div>

              <div className="branch-card">
                <h5>Chennai Office</h5>
                <p>No. 12-B, 1st Main Road, Kalaimagal Nagar, Chennai, Tamil Nadu</p>
              </div>

              <div className="branch-card">
                <h5>Hyderabad Office</h5>
                <p>Office No 301 Model House, Saibaba Temple Rd, Dwarakapuri</p>
              </div>

              <div className="branch-card">
                <h5>Mumbai Office</h5>
                <p>Sahara Plaza Office No 201, A K Road, Andheri East, Mumbai 400059</p>
              </div>

              <div className="branch-card">
                <h5>Ahmedabad Office</h5>
                <p>Sagar Plaza Office No 202, Maskane Burhani, Khanpur, Ahmedabad</p>
              </div>

              <div className="branch-card">
                <h5>Aurangabad Office</h5>
                <p>Office No. 206, Awargaonkar Complex, Jalna Road, Aurangabad</p>
              </div>
            </div>

            {/* RIGHT COLUMN */}
            <div className="col-lg-6 col-md-6 col-sm-12 mb_30">
              <div className="branch-card">
                <h5>Nagpur Office</h5>
                <p>Sai Deep Complex Office No 203A, Dobi Nagar, Nagpur 440015</p>
              </div>

              <div className="branch-card">
                <h5>Indore Office</h5>
                <p>01/3 LIG Colony, Behind LIG Gurudhwara, Indore 452001</p>
              </div>

              <div className="branch-card">
                <h5>Baroda Office</h5>
                <p>
                  Ground Floor Office No 28, Opp Sai Baba Temple, Subhanpura,
                  Vadodara 390023
                </p> 
              </div>

              <div className="branch-card">
                <h5>Surat Office</h5>
                <p>Someshwar Square, Office 220, Vesu, Surat 395007</p>
              </div>

              <div className="branch-card">
                <h5>Ranchi Office</h5>
                <p>NH 75, Kathalkocha, Ranchi, Jharkhand 834002</p>
              </div>

              <div className="branch-card">
                <h5>Jamshedpur Office</h5>
                <p>Shivsai Complex, SNP Area, Sakchi, Jamshedpur 831001</p>
              </div>

              <div className="branch-card">
                <h5>Bhubaneswar Office</h5>
                <p>Jagannath Nagar Road 14, Inox Complex Office No 201, Bhubaneswar</p>
              </div>
            </div>

          </div>

        </div>
      </section>

      {/* ====================================================== */}
      {/*        GOOGLE MAP                                     */}
      {/* ====================================================== */}
      <section className="google-map-section">
        <div className="container">
          {/* <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3117.527604736206!2d73.9374114!3d18.5558542!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c3d8c5eaaaab%3A0x2f83e51b1eacecfd!2sPUNE%20CORPORATE%20CARS%20INDIA%20PRIVATE%20LIMITED!5e1!3m2!1sen!2sin!4v1764057042268!5m2!1sen!2sin"
            width="100%"
            height="450"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe> */}


          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2880.806902763053!2d73.948329!3d18.5748324!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c3a24a05c2e9%3A0xe0adac94b3791e47!2sACC%20CONCRETE%20KHARADI!5e1!3m2!1sen!2sin!4v1785574582007!5m2!1sen!2sin"  width="100%"
            height="450"   allowfullscreen="" loading="lazy" referrerpolicy="strict-origin-when-cross-origin"></iframe>

        </div>
      </section>
    </>
  );
};

export default ContactPage;
